import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { StreamData } from 'types/streamData'
import { useDisplayTheme } from 'hooks/useUiState'
import i18n from 'i18n'

import { StyledLink } from '../index.css'

const INSTAGRAM_URL = `https://instagram.com/`

const StyledPhotoUserTagContent = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  line-height: 22px;
  font-size: ${sys.typescale[14].size};
  font-weight: 400;
  padding-top: 8px;
  word-break: break-word;

  & a {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
    &:hover {
      color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.hover};
    }
  }
`

const getMessage = (photoUserTags: string[], theme: Theme) => {
  if (photoUserTags.length <= 3) {
    return (
      <>
        {`${i18n.t('taggedUser_other')}: `}
        {photoUserTags.map((photoUserTag, index) => (
          <>
            {index > 0 ? ', ' : ''}
            <StyledLink
              mode={theme}
              target="_blank"
              rel="noreferrer"
              onClick={(event) => {
                event.stopPropagation()
              }}
              href={`${INSTAGRAM_URL}${photoUserTag}`}>
              {photoUserTag}
            </StyledLink>
          </>
        ))}
      </>
    )
  }
  return (
    <>
      {`${i18n.t('taggedUser_other')}: `}
      <StyledLink
        mode={theme}
        target="_blank"
        rel="noreferrer"
        onClick={(event) => {
          event.stopPropagation()
        }}
        href={`${INSTAGRAM_URL}${photoUserTags[0]}`}>
        {photoUserTags[0]}
      </StyledLink>
      ,&nbsp;
      <StyledLink
        mode={theme}
        target="_blank"
        rel="noreferrer"
        onClick={(event) => {
          event.stopPropagation()
        }}
        href={`${INSTAGRAM_URL}${photoUserTags[1]}`}>
        {photoUserTags[1]}
      </StyledLink>
      {` ${i18n.t('andOthers', { count: photoUserTags.length - 2 })}`}
    </>
  )
}

type PhotoUserTagContentProps = {
  streamData: StreamData
}

const PhotoUserTagContent = ({ streamData }: PhotoUserTagContentProps) => {
  const theme = useDisplayTheme() as Theme
  const { photoUserTags } = streamData

  return (
    <StyledPhotoUserTagContent mode={theme}>
      {getMessage(photoUserTags!, theme)}
    </StyledPhotoUserTagContent>
  )
}

export default PhotoUserTagContent
